import React from "react";

const MaduLagoonTour = () => {
    return (
        <div className="p-6 bg-blue-50 rounded-2xl shadow-md max-w-5xl mx-auto text-gray-800 mt-10">
            <h2 className="text-3xl font-bold text-blue-900 mb-4">🌅 Madu Lagoon Tour</h2>

            <div className="space-y-4">
                {/* Start Times */}
                <div>
                    <h3 className="text-xl font-semibold">🚤 Start Times:</h3>
                    <ul className="list-disc ml-5">
                        <li>Sunrise Tour – <strong>5:35 AM</strong></li>
                        <li>Morning Tour – <strong>10:00 AM</strong></li>
                        <li>Evening Tour – <strong>3:30 PM</strong></li>
                    </ul>
                </div>

                {/* Duration */}
                <div>
                    <h3 className="text-xl font-semibold">⏱ Duration:</h3>
                    <p>Approximately <strong>2½ hours</strong></p>
                </div>

                {/* Boat Ticket Prices */}
                <div>
                    <h3 className="text-xl font-semibold">🎟️ Boat Ticket Prices:</h3>
                    <ul className="list-disc ml-5">
                        <li>1 Person – 20€</li>
                        <li>2 People – 25€</li>
                        <li>3 People – 30€</li>
                        <li>4 People – 40€</li>
                        <li>5 People – 50€</li>
                    </ul>
                </div>

                {/* Transport */}
                <div>
                    <h3 className="text-xl font-semibold">🚕 Optional Transport:</h3>
                    <ul className="list-disc ml-5">
                        <li>Tuk Tuk – 2€</li>
                        <li>Car – 10€</li>
                        <li>Van – 15€</li>
                    </ul>
                </div>

                {/* Includes */}
                <div>
                    <h3 className="text-xl font-semibold">✅ Included:</h3>
                    <p>Bottled Water</p>
                </div>

                {/* Highlights */}
                <div>
                    <h3 className="text-xl font-semibold">📍 Tour Highlights:</h3>
                    <ul className="list-disc ml-5">
                        <li><strong>Cinnamon Island</strong> – Learn how cinnamon and cinnamon oil are produced</li>
                        <li><strong>Bird Island</strong></li>
                        <li><strong>Buddhist Temple Island</strong></li>
                        <li><strong>Baby Crocodile with Photos</strong></li>
                        <li>
                            <strong>Wildlife Sightings:</strong> Bats, Water Monitors, Monkeys, Eagles, Kingfishers, Cormorants, Storks, Squirrels
                        </li>
                        <li>Beautiful Flowers and a <strong>Mangrove Forest</strong> that will <strong> amaze you </strong></li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default MaduLagoonTour;
